<template>
  <div class="text-br-red fluid-xs leading-tightest text-medium py-2">
    <slot></slot>
  </div>
</template>
